import { useSelector} from "react-redux";
import { useEffect, useState} from "react";
//import axios from "axios";
import HomeItem from "../Components/HomeItem";
import styles from "../Components/ProductList.module.css";
import Carousel from "../Components/Carousel";
//import Marquee from "react-fast-marquee";
import Api from "../api/ecomApi";
//import { style } from "framer-motion/m";

const Home = () => {  
  const [shops, setShops] = useState([]);
  useSelector(store => store.deliveryCity);
  const selectedDeliveryCity = localStorage.getItem('deliveryCity') ?? 'defaultAll';//localStorage.getItem('deliveryCity'); 
  // if(selectedDeliveryCity==='All'){
  //   alert('Please select your delivery city!!!');
  // }
    useEffect(() => {       
    Api.get(`all-shops/${selectedDeliveryCity}`)
        .then((response) => {
            setShops(response.data)
        })
      .catch((error) => {
        console.log(`Hello${error}`);
      });
  }, [selectedDeliveryCity]);
        
    return <>
    <div className={`col-sm-12 ${styles.mainContainer}`}>
        <div className="container-fluid">        
          <div className="row">
            <Carousel />
          </div> 
          {shops.length!==0 ? <div className="row">        
            {shops.map((item) => (<HomeItem key={item.id} item={item} />
            ))}
          </div> : <div className="row"><h5 className={styles.shopComingSoon}>Coming very soon....</h5></div>}        
          
        </div>
      </div>

    </>

}
export default Home;